import { CloseIcon } from '@/components/icons'
import { Box, Stack, Typography } from '@mui/material'
import { FC } from 'react'
import classes from './styles.module.scss'
import clsx from 'clsx'

interface ConfigHeaderProps {
  title: string | any
  onCancel: () => void,
  showBtnClose?: boolean
}

const SetUpHeaderModal: FC<ConfigHeaderProps> = ({ title, onCancel, showBtnClose = true }) => {
  return (
    <Stack
      bgcolor="background.overrideDefault"
      direction="row"
      className={classes.header}
    >
      {showBtnClose && (
        <Box color="text.main" className={classes.headerBtn} onClick={onCancel}>
          <CloseIcon />
        </Box>
      )}
      <Typography color="text.main" 
        className={clsx(
          classes.headerText,
          {[classes.hasBtnClose]: showBtnClose}
        )}
      >
        {title}
      </Typography>
    </Stack>
  )
}

export default SetUpHeaderModal
